import React, { useEffect, useState } from 'react';
import { Checkbox, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Button_mui from '@mui/material/Button';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { GroupListType, GetAllGroupList } from '../../../function/GroupDataModel';

import DateTImeDiv from '../../atoms/Div/DateTImeDiv';
import ConfirmDialog, { ConfirmDialogResponse } from '../../atoms/Dialog/ConfirmDialog';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TableBaseStyle } from '../../../baseStyle/tableBaseStyle';

import IoTDevListStudyButton from './IoTDevListStudyButton';
import IoTDevListLearnResultButton from '../../molecules/Button/DevListLearnResultButton';
import SimpleDialog from '../../atoms/Dialog/SimpleDialog';
import GropuListComGrid from '../../molecules/Grid/GropuListComGrid';

import { CollectionStatsuType, IOT_MACHINE_STATUS_OBSERVE_SPAN, LearnStatType } from '../../../Constant';
import {
  GetIoTBoxDeviceLists,
  IoTBoxDeviceLists,
  SetInstructManualCollection,
  V_IOTBOX_DEV_LIST,
  SetStudyCollection,
  cancelStudyCollection,
  StopRecollection,
} from './IoTDevList';
import IoTDevListFooter from './IoTDevListFooter';
import { useModal } from '../../../function/useModal';
import LearnResultDialog, { LearnResultDialogResponse } from '../../molecules/Dialog/LearnResultDialog';
import { IoTDevListStyle, TableUseStyle } from './IoTDevListStyle';
import IoTDevListHealthyButton from './IoTDevListHealthyButton';
import IotDevListStatButton from './IotDevListStatButton';

type Props = {
  tableContainerStyle: string;
};

const ApiResponseCode = {
  DEFAULT: 200,
  SUCCESS: 204, //IoTBox手動収集　登録要求待ちレコード追加
  BAD_REQUEST: 400, //パラメータ異常
  NOT_ACCEPTABLE: 406, //状態チェック
  NOT_CANCEL_STATUDY_COUNT: 407, //学習カウント異常
  CANCEL_REQ_ALREADY_SEND: 408, //学習キャンセル済みエラー
  UPDATE_FAILURE: 500, //更新失敗
  SERVICE_UNAVAILABLE: 503, //ネットワーク接続失敗
} as const;
type ApiResponseCode = typeof ApiResponseCode[keyof typeof ApiResponseCode];

/**
 * IoTBox機器一覧
 * @param props
 * @returns
 */
const IoTDevListGrid: React.FC<Props> = (props) => {
  const tableBaseStyle = TableUseStyle();
  const baseClasses = TableBaseStyle();
  const pageStyle = IoTDevListStyle();
  const history = useHistory();
  const { t } = useTranslation(); //言語切り替え
  const [selectedID, setSelectedID] = useState(0);
  const [iotBoxdeviceArray, setIoTBoxDeviceArray] = useState<IoTBoxDeviceLists>();
  const [messageDialogOpen, setMessageDialogOpen] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState<string>('');
  const [open, setOpen] = React.useState(false);
  const [deviceIndex, setDeviceIndex] = React.useState(0);
  const [groupListInfo, setGroupListInfo] = useState<GroupListType>({
    TM_TRD_GROUP_SETs: [],
    RT_TRD_GROUP_SETs: [],
    PH_CUR_GROUP_SETs: [],
    SIG_CMP_GROUP_SETs: [],
    SIGC_CMP_GROUP_SETs: [],
    FFT_CMP_GROUP_SETs: [],
    FFTC_CMP_GROUP_SETs: [],
    XY_CMP_GROUP_SETs: [],
    GroupListsComModels: [],
    TrendSettings: {
      MeasKinds: [],
      DeviceLists: [],
      ItemLists: [],
      DataKinds: [],
      AlarmKinds: [],
      AlarmLimits: [],
      DeviceUnitInfos: [],
      ColSetInfos: [],
      KIND_NO_NAME_SETs: [],
      JudgeSetSelect: [],
      MClcTypes: [],
      SetPartDisList: [],
    },
    PhCurSelectItems: [],
    DeviceSelects: [],
    DeviceConanSelects: [],
    XYDeviceSelects: [],
  });
  
  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [dlgmsg, setDlgmsg] = useState<string>('');
  
  const cfmdlg = flgCfmDlg ? (
      <ConfirmDialog
        dialog={actCfmDlg}
        message={dlgmsg}
        action={t('OffLineJudgePage.はい', 'はい')}
        cancel={t('OffLineJudgePage.いいえ', 'いいえ')}
      />
    ) : null;

  //学習結果ダイアログ
  const [flgLearnResDlg, learnResDlg] = useModal<LearnResultDialogResponse>();

  useEffect(() => {
    console.debug('--- useEffect ---');
    getData();
    const interval = setInterval(() => {
      console.debug('--- setInterval ---');
      getData();
    }, IOT_MACHINE_STATUS_OBSERVE_SPAN); //  intervals

    return () => {
      console.debug('--- clearInterval ---');
      clearInterval(interval);
    };
  }, []);

  /**
   * IoTBox機器一覧リスト取得
   */
  const getData = () => {
    GetIoTBoxDeviceLists().then((ret) => {
      //console.debug(['--- GetIoTBoxDeviceLists  ret ---', ret]);
      setIoTBoxDeviceArray(ret);
    });
  };

  /**
   * 手動収集開始
   * @param e
   */
  const handleInstructManualCollection = (e: V_IOTBOX_DEV_LIST, index: number) => {
    console.debug(['handleInstructManualCollection()'], e.IMSI_NO, index);

    if (e.IOT_SET.LOCAL_VER !== e.IOT_SET.SET_VER) {
      setShowMessage(
        t(
          'IoTDevListGrid.設定がAWSへUPLOADできていないため実行できません',
          '設定がAWSへUPLOADできていないため実行できません'
        )
      );
      setMessageDialogOpen(true);
      return;
    }

    //再収集中の停止処理
    if(e.IOT_SET.RECOLLECTION_COUNT != undefined && e.IOT_SET.RECOLLECTION_COUNT  >= 1){
      setDlgmsg(t('IoTDevListGrid.再収集処理実行中です_停止しますか', '再収集処理実行中です。停止しますか?'));
      actCfmDlg
        .open()
        .apply((_) => {
          // ボタンを無効化しておく
        if (iotBoxdeviceArray) {
          iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].IS_MANUAL_COLRECT = false;
          setIoTBoxDeviceArray({ ...iotBoxdeviceArray });
        }

        StopRecollection(e.IMSI_NO)
      .then((status: number) =>{
        console.debug(['status', status]);
        if (status != ApiResponseCode.SUCCESS){
          // 再収集停止失敗時
          if (iotBoxdeviceArray) {
            iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].IS_MANUAL_COLRECT = true;
            console.debug(['再収集処理の停止処理失敗', iotBoxdeviceArray.V_IOTBOX_DEV_LISTS]);
            setIoTBoxDeviceArray({ ...iotBoxdeviceArray });
          }
          // ダイアログ表示
          if (status == ApiResponseCode.SERVICE_UNAVAILABLE) {
            setShowMessage(t('IoTDevListGrid.ネットワーク接続エラー', 'ネットワーク接続エラー'));
          } else {
            setShowMessage(t('IoTDevListGrid.再収集処理停止不可', '再収集処理停止不可'));
          }
          setMessageDialogOpen(true);
        }else{
          if (iotBoxdeviceArray) {
            iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].IS_MANUAL_COLRECT = true;
            setIoTBoxDeviceArray({ ...iotBoxdeviceArray });
          }
        }
      })
      .catch((reason) => {
        //reject(reason);
      });
      return;
          
         })
         .cancel(() => {
           console.debug(t('OffLineJudgePage.キャンセル', 'キャンセル'));
         });
         
    
      return;
    }
    // ボタンを無効化しておく
    if (iotBoxdeviceArray) {
      iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].IS_MANUAL_COLRECT = false;
      iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].IS_STUDY_CHECK = false;
      console.debug(['ボタン無効化 1', iotBoxdeviceArray.V_IOTBOX_DEV_LISTS]);
      setIoTBoxDeviceArray({ ...iotBoxdeviceArray });
    }

    //手動収集開始処理
    SetInstructManualCollection(e.IMSI_NO)
      .then((status: number) => {
        console.debug(['status', status]);
        if (status != ApiResponseCode.SUCCESS) {
          // 手動収集開始失敗時
          if (iotBoxdeviceArray) {
            //iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].GET_FLG = CollectionStatsuType.ERROR;
            iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].IS_MANUAL_COLRECT = true;
            console.debug(['手動収集開始失敗', iotBoxdeviceArray.V_IOTBOX_DEV_LISTS]);
            setIoTBoxDeviceArray({ ...iotBoxdeviceArray });
          }
          // ダイアログ表示
          if (status == ApiResponseCode.SERVICE_UNAVAILABLE) {
            setShowMessage(t('IoTDevListGrid.ネットワーク接続エラー', 'ネットワーク接続エラー'));
          } else {
            setShowMessage(t('IoTDevListGrid.手動収集実行不可', '手動収集実行不可'));
          }
          setMessageDialogOpen(true);
        } else {
          // 手動収集開始成功時は収集中
          if (iotBoxdeviceArray) {
            iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].GET_FLG = CollectionStatsuType.COLLECTING;
            iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].IOT_SET.AUTO_RETRY_COUNT = 0;
            iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].GET_FLG = CollectionStatsuType.COLLECTING;
            //console.debug(['手動収集開始成功', iotBoxdeviceArray.V_IOTBOX_DEV_LISTS]);
            setIoTBoxDeviceArray({ ...iotBoxdeviceArray });
          }
        }
        //resolve('done');
      })
      .catch((reason) => {
        //reject(reason);
      });
  };

  /**
   * 学習モード開始
   * @param e
   */
  const handleStudyCollection = (e: V_IOTBOX_DEV_LIST, index: number) => {
    console.debug(['handleStudyCollection()'], e.IMSI_NO, index);
    if (iotBoxdeviceArray) {
      iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].IS_MANUAL_COLRECT = false;
      //iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].IS_STUDY_CHECK = false;
      //iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].STUDY_FLG = 1;
      iotBoxdeviceArray.V_IOTBOX_DEV_LISTS[index].IOT_SET.STUDY_STATUS = 2;
      setIoTBoxDeviceArray({ ...iotBoxdeviceArray });
    }

    SetStudyCollection(e.IMSI_NO)
      .then((status: number) => {
        console.debug(['status', status]);
        if (status !== ApiResponseCode.SUCCESS) {
          // ダイアログ表示
          if (status == ApiResponseCode.SERVICE_UNAVAILABLE) {
            setShowMessage(t('IoTDevListGrid.ネットワーク接続エラー', 'ネットワーク接続エラー'));
          } else {
            setShowMessage(t('IoTDevListStudyButton.学習機能実行不可', '学習機能実行条件がそろっていません'));
          }
          setMessageDialogOpen(true);
        }
      })
      .catch((reason) => {
        setShowMessage(t('IoTDevListStudyButton.学習機能実行不可', '学習機能実行条件がそろっていません'));
        setMessageDialogOpen(true);
      });
  };

  /**
   * 学習処理の中断処理
   * @param e
   * @param index
   */
  const CancelHandleStudyCollection = (e: V_IOTBOX_DEV_LIST, index: number) => {
    console.debug(['CancelHandleStudyCollection()'], e.IMSI_NO, index);

    cancelStudyCollection(e.IMSI_NO)
      .then((status: number) => {
        console.debug(['status', status]);
        if (status !== ApiResponseCode.DEFAULT) {
          // ダイアログ表示
          if (status == ApiResponseCode.SERVICE_UNAVAILABLE) {
            setShowMessage(t('IoTDevListGrid.ネットワーク接続エラー', 'ネットワーク接続エラー'));
          } else if (status == ApiResponseCode.NOT_CANCEL_STATUDY_COUNT) {
            setShowMessage(t('IoTDevListGrid.学習回数エラー', '最後の学習中の為キャンセルできません'));
          } else if (status == ApiResponseCode.CANCEL_REQ_ALREADY_SEND) {
            setShowMessage(t('IoTDevListGrid.学習キャンセル要求済み', '既に学習キャンセル要求済みです'));
          }
        } else {
          setShowMessage(t('IoTDevListStudyButton.学習機能キャンセル成功', '学習キャンセル要求をしました'));
        }
        setMessageDialogOpen(true);
      })
      .catch((reason) => {
        setShowMessage(t('IoTDevListStudyButton.学習機能キャンセル不可', '学習機能のキャンセルに失敗しました'));
        setMessageDialogOpen(true);
      });
  };

  /**
   * 画面更新ボタン
   */
  const handleupdateScreenAction = () => {
    console.debug('updateScreenAction()');
    getData();
  };

  /**
   * 収集結果
   * @param val 
   * @param retryStatus 
   * @param recollectionStatus 
   * @returns 
   */
  const collectionResult = (val?: CollectionStatsuType, retryStatus?: number,recollectionStatus?: number): string => {
    if (val == undefined) return t('IoTDevListGrid.不明', '不明');

    let retryStatusVal: number = 0;
    if (retryStatus) {
      retryStatusVal = retryStatus;
    }
    let recollectionStatusVal: number = 0;
    if(recollectionStatus){
      recollectionStatusVal = recollectionStatus;
    }

    switch (val) {
      case CollectionStatsuType.COLLECTING:
        switch (retryStatusVal) { //リトライ確認
          case 0:
            switch(recollectionStatusVal){  //再収集確認
              case 0:
                return t('IoTDevListGrid.収集中', '収集中');
                default:
                  return t('IoTDevListGrid.収集中_再収集中','収集中(再収集中)');
            }            
          default:
            return t('IoTDevListGrid.収集中_リトライ中', '収集中(リトライ中)');
        }

      case CollectionStatsuType.END:
        switch (retryStatusVal) { //リトライ確認
          case 0:
            switch(recollectionStatusVal){  //再収集確認
              case 0:
                return t('IoTDevListGrid.完了', '完了');
              default:
                return t('IoTDevListGrid.再収集中', '再収集中');
            }
          default:
            return t('IoTDevListGrid.リトライ中', 'リトライ中');
        }
      case CollectionStatsuType.ERROR:
        switch (retryStatusVal) { //リトライ確認
          case 0:
            switch(recollectionStatusVal){  //再収集確認
              case 0:
                return t('IoTDevListGrid.失敗', '失敗');
              default:
                return t('IoTDevListGrid.再収集中', '再収集中');
            }
          default:
            return t('IoTDevListGrid.リトライ中', 'リトライ中');
        }
      default:
        return t('IoTDevListGrid.不明', '不明');
    }
  };

  const getCollectionState = (row?: V_IOTBOX_DEV_LIST): string => {
    if (row == undefined) return tableBaseStyle.bodyCellError;
    if (row.IOT_SET.GET_FLG == 0) {
      return tableBaseStyle.bodyCellRun;
    }
    if (row.IOT_SET.GET_FLG == 1) {
      return tableBaseStyle.bodyCellEnd;
    }
    return tableBaseStyle.bodyCellError;
  };

  /**
   * 行クリックハンドラ
   * @param e
   * @param index
   */
  const handleTableCellClick = (e: V_IOTBOX_DEV_LIST, index: number) => {
    console.debug(['handleTableCellClick()'], selectedID, index);
    if (selectedID == index + 1) {
      setDeviceIndex(e.DEV_INDEX);
      GetAllGroupList(e.DEV_INDEX).then((ret) => {
        setGroupListInfo(ret);
        handleDialogShow();
      });
    }
  };
  const handleDialogShow = () => {
    setOpen(true);
  };

  const handleDialogClose = () => {
    console.debug('handleDialogClose');
    setOpen(false);
  };
  const handleTransitionPage = (pathname: string, state: any) => {
    history.push({
      pathname: pathname,
      state: state,
    });
  };

  const lrdlg = flgLearnResDlg ? <LearnResultDialog dialog={learnResDlg} devIndex={deviceIndex} /> : null;

  //行選択の背景色一時置き
  let lineSelection = '';

  console.debug(['- 画面描画開始 -', iotBoxdeviceArray?.V_IOTBOX_DEV_LISTS]);
  return (
    <>
      <div className={`${(lineSelection = tableBaseStyle.bodyRow)} ${(lineSelection = baseClasses.bodyRow)}`}></div>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center">
        <Grid item xs={12}>
          <TableContainer component={Paper} className={props.tableContainerStyle}>
            <Table stickyHeader aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell}>{t('IoTDevListGrid.No', 'No')}</TableCell>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('IoTDevListGrid.機器番号_名称', '機器番号・名称')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell}>{t('IoTDevListGrid.状態', '状態')}</TableCell>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('IoTDevListGrid.IoTBox状態', 'IoTBox状態')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('IoTDevListGrid.最新収集時刻', '最新収集時刻')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('IoTDevListGrid.手動収集', '手動収集')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('IoTDevListGrid.次回収集予定', '次回収集予定')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('IoTDevListGrid.学習処理', '学習処理')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('IoTDevListGrid.学習結果', '学習結果')}
                  </TableCell>

                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('IoTDevListGrid.収集結果', '収集結果')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {iotBoxdeviceArray?.V_IOTBOX_DEV_LISTS.map((row, index) => (
                  <TableRow
                    key={index}
                    hover
                    onClick={() => {
                      setSelectedID(index + 1);
                    }}
                    selected={selectedID === index + 1}
                    className={lineSelection}
                  >
                    {/* No */}
                    <TableCell className={tableBaseStyle.bodyCell} onClick={(e) => handleTableCellClick(row, index)}>
                      {index + 1}
                    </TableCell>
                    {/* 機器番号・名称 */}
                    <TableCell className={tableBaseStyle.bodyCell} onClick={(e) => handleTableCellClick(row, index)}>
                      {row.DEV_NO + row.DEV_NAME}
                    </TableCell>
                    {/* 状態 */}
                    <TableCell className={tableBaseStyle.bodyCell}>
                      {<IotDevListStatButton iotBoxData={row}></IotDevListStatButton>}
                    </TableCell>
                    {/* IoTBox状態 */}
                    {row.IMSI_NO === '-1' ? (
                      <TableCell className={tableBaseStyle.bodyCell}>
                        {/**部分放電とコナンエアーの場合はハイフン表示 */}―
                      </TableCell>
                    ) : (
                      <TableCell className={tableBaseStyle.bodyCell}>
                        {<IoTDevListHealthyButton iotBoxData={row}></IoTDevListHealthyButton>}
                      </TableCell>
                    )}
                    {/* 最新収集日時 */}
                    <TableCell className={getCollectionState(row)} onClick={(e) => handleTableCellClick(row, index)}>
                      <DateTImeDiv value={row.LOG_NEW} format={'YYYY/MM/DD HH:mm:ss'} />
                    </TableCell>
                    {/* 手動収集 */}
                    <TableCell className={tableBaseStyle.bodyCell}>
                      {/**部分放電とコナンエアーの場合収集不可にする */}
                      <Button
                        style={{
                          width: '130px',
                        }}
                        variant="outlined"
                        color="secondary"
                        disabled={!row.IS_MANUAL_COLRECT || row.IOT_SET.RECOLLECTION_STOP_FLG === 1}
                        onClick={(e) => handleInstructManualCollection(row, index)}
                      >
                        {row.IMSI_NO === '-1'
                          ? t('IoTDevListGrid.収集不可', '収集不可')
                          : (row.IOT_SET.RECOLLECTION_COUNT == null || row.IOT_SET.RECOLLECTION_COUNT == 0 ? 
                            t('IoTDevListGrid.開始', '開始'): t('IoTDevListGrid.再収集停止', '再収集停止'))}
                      </Button>
                    </TableCell>
                    {/* 次回収集時刻 */}
                    <TableCell className={tableBaseStyle.bodyCell}>
                      <DateTImeDiv value={row.LOG_NEXT} format={'YYYY/MM/DD HH:mm:ss'} />
                    </TableCell>
                    {/* 学習処理 */}
                    <TableCell className={tableBaseStyle.bodyCell}>
                      <IoTDevListStudyButton
                        studyStatus={row.IOT_SET.STUDY_STATUS ?? 0}
                        studyCount={row.IOT_SET.STUDY_COUNT ?? 0}
                        isStudyCheck={row.IS_STUDY_CHECK && row.IOT_SET.RECOLLECTION_STOP_FLG !== 1}
                        isStudyCancelCheck={row.IS_STUDY_CANCEL_CHECK}
                        isStudyCancelRun={row.IS_STUDY_CANCEL_RUN}
                        onClick={() => {
                          if (row.IOT_SET.STUDY_STATUS !== undefined) {
                            handleStudyCollection(row, index);
                          }
                        }}
                        onCancelClick={() => {
                          if (row.IOT_SET.STUDY_STATUS !== undefined) {
                            CancelHandleStudyCollection(row, index);
                          }
                        }}
                      />
                    </TableCell>
                    {/* 学習結果 */}
                    {row.IMSI_NO === '-1' ? (
                      <TableCell className={tableBaseStyle.bodyCell}>
                        {/**部分放電とコナンエアーの場合はハイフン表示 */}―
                      </TableCell>
                    ) : (
                      <TableCell className={tableBaseStyle.bodyCell}>
                        <IoTDevListLearnResultButton
                          learnStat={row.LEARN_STAT ?? 0}
                          onClick={() => {
                            setDeviceIndex(row.DEV_INDEX);
                            learnResDlg.open();
                          }}
                        />
                      </TableCell>
                    )}

                    {/* 収集結果 */}
                    <TableCell className={tableBaseStyle.bodyCell} width={150}>
                      {collectionResult(row.GET_FLG, row.IOT_SET.AUTO_RETRY_COUNT,row.IOT_SET.RECOLLECTION_COUNT)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12}>
          <IoTDevListFooter onClickUUpdateScreenButton={handleupdateScreenAction} />
        </Grid>
      </Grid>

      <SimpleDialog
        open={messageDialogOpen}
        onClose={() => setMessageDialogOpen(false)}
        //title={t('IoTDevListGrid.警告', '警告')}
        okText={t('IoTDevListGrid.OK', 'OK')}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </SimpleDialog>
      {/**グループ一覧ダイアログ表示 */}
      <Dialog open={open} fullWidth maxWidth="lg">
        <DialogTitle id="alert-dialog-title">{t('IoTDevListGrid.グループ一覧', 'グループ一覧')}</DialogTitle>
        <DialogContent>
          <GropuListComGrid
            deviceIndex={deviceIndex}
            groupInfo={groupListInfo}
            onDataSelectAction={handleTransitionPage}
          />
        </DialogContent>
        <DialogActions>
          <Button
            className={pageStyle.buttonStyle}
            variant="contained"
            color="primary"
            disableElevation
            onClick={handleDialogClose}
          >
            {t('IoTDevListGrid.閉じる', '閉じる')}
          </Button>
        </DialogActions>
      </Dialog>
      {lrdlg}
      {cfmdlg}
    </>
  );
};
export default IoTDevListGrid;
